import { useField } from "formik";
import React from "react";
import { Switch } from "@headlessui/react";
import { packClasses } from "Util";
import BaseElement from "./BaseElement";

export default function TextInput(props) {
    const defaultProps = {
        label: "Text",
        id: "text-input",
        name: "text-input",
        autoComplete: "off",
        value: "",
        isError: false,
        errorText: "",
        variant: false,
        onChange: () => {},
    };
    const useProps = Object.assign(defaultProps, {}, props);
    const [field, meta] = useField(props);

    const onChange = (val) => {
        field.onChange({
            target: {
                id: field.id,
                name: field.name,
                getAttribute: function () {
                    return true;
                },
                value: val,
            },
        });
    };

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const helperText = useProps.helpertext ? (
        <p className="mt-1.5 text-xs text-gray-500">{useProps.helpertext}</p>
    ) : (
        ""
    );

    const errorText =
        useProps.isError || (meta.touched && meta.error) ? (
            <p className="mt-2 text-sm text-red-600">
                {useProps.errorText}
                {meta.error}
            </p>
        ) : (
            ""
        );

    const input = (
        <Switch.Group as="div">
            <Switch
                checked={field.value}
                onChange={onChange}
                disabled={useProps.disabled === true}
                className={packClasses(
                    field.value ? "bg-green-600" : "bg-gray-200",
                    "focus:outline-none relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
                )}
            >
                <span className="sr-only">Use setting</span>
                <span
                    aria-hidden="true"
                    className={packClasses(
                        field.value ? "translate-x-5" : "translate-x-0",
                        "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                    )}
                />
            </Switch>
            <Switch.Label as="span" className="ml-3">
                {helperText}
                {errorText}
            </Switch.Label>
        </Switch.Group>
    );

    return (
        <BaseElement
            {...useProps}
            label={label}
            input={input}
            helpertext=""
            errortext=""
        />
    );
}
